<div class="main">
  <!-- <div class="progress-holder">
    <div
      class="progress"
      style="right: 0"
      [ngStyle]="{
        background: currentIndex >= 1 ? '#0073ff' : 'rgba(0, 115, 255, 0.24)'
      }"
    ></div>
    <div
      class="progress"
      style="right: calc(25% + 4px)"
      [ngStyle]="{
        background: currentIndex >= 2 ? '#0073ff' : 'rgba(0, 115, 255, 0.24)'
      }"
    ></div>
    <div
      class="progress"
      style="right: calc(50% + 8px)"
      [ngStyle]="{
        background: currentIndex >= 3 ? '#0073ff' : 'rgba(0, 115, 255, 0.24)'
      }"
    ></div>
    <div
      class="progress"
      style="right: calc(75% + 12px)"
      [ngStyle]="{
        background: currentIndex >= 4 ? '#0073ff' : 'rgba(0, 115, 255, 0.24)'
      }"
    ></div>
  </div> -->
  <!-- <div class="go-to-app" (click)="goToApp()">
    <img src="assets/general/cross-blue.svg" />
  </div> -->
  <div
    class="page"
    style="right: 0"
    id="1Page"
    (swipeleft)="swipe($event.type)"
    (swiperight)="swipe($event.type)"
  >
    <div class="image">
      <img
        style="width: 227px; height: 151px"
        src="assets/intro/1.svg"
        class="img"
      />
    </div>
    <!-- <div class="title">سریع و آسان در مسیر سلامتی پیشرفت کنید.</div> -->
    <div class="content">
      <p class="intro-title">مسیر سلامتی خود را مشاهده کنید</p>
      <p>
        با استفاده از گزارش و نمودارهای شخصی‌سازی شده، تغییرات وزن و عادت‌های
        سالمی‌ را که ساخته‌اید مشاهده کنید و از مسیر لذت ببرید!
      </p>
    </div>
  </div>
  <div
    class="page"
    id="2Page"
    (swipeleft)="swipe($event.type)"
    (swiperight)="swipe($event.type)"
  >
    <div class="image">
      <img
        style="width: 227px; height: 188px"
        src="assets/intro/2.svg"
        class="img"
      />
    </div>
    <div class="content">
      <p class="intro-title">سالم خوری را با غذا های خوشمزه تجربه کنید</p>
      <p>
        با برنامه غذایی مغذی, در دسترس و خوشمزه که مطابق ذائقه و تصمیم شما قابل
        تغییرند را راحت تر به هدف برسید.
      </p>
    </div>
  </div>
  <div
    class="page"
    id="3Page"
    (swipeleft)="swipe($event.type)"
    (swiperight)="swipe($event.type)"
  >
    <div class="image">
      <img
        style="width: 227px; height: 177px"
        src="assets/intro/3.svg"
        class="img"
      />
    </div>
    <div class="content">
      <p class="intro-title">از متخصص تغذیه رژیم بگیرید</p>
      <p>
        به کمک رژیم‌های متنوع، بروز و علمی، سریع‌ و آسان به نتیجه دلخواه برسید.
      </p>
    </div>
  </div>
  <div class="progress-bullet">
    <span [ngClass]="{ active: currentIndex == 1 }"></span>
    <span [ngClass]="{ active: currentIndex == 2 }"></span>
    <span [ngClass]="{ active: currentIndex == 3 }"></span>
  </div>
  <div class="start-button" (click)="goToApp()">شروع</div>
  <!-- <div *ngIf="currentIndex === 4" class="start-button" (click)="goToApp()">
    شروع کنید
  </div> -->
</div>
